import http from 'hub-http/clients/apiClient';
export const fetchCallSummary = ({
  executionId
}) => http.get(`/content-assistance/v3/command-executions/${executionId}`);
export const generateCallSummary = callCrmObjectId => http.post(`calls/v1/call-summaries`, {
  data: {
    callCrmObjectId
  }
});